import React from 'react';
import TermsTemplate from './TermsTemplate';

export default function MarketingConsent() {
  const content = `
    <h2>제1조 (목적)</h2>
    <p>본 동의서는 클로젯(이하 "회사")이 이용자에게 마케팅 정보를 제공함에 있어 필요한 사항을 규정함을 목적으로 합니다.</p>

    <h2>제2조 (마케팅 정보의 내용)</h2>
    <p>회사가 제공하는 마케팅 정보는 다음과 같습니다.</p>
    <ol>
      <li>신규 상품 및 서비스 안내</li>
      <li>이벤트 및 프로모션 정보</li>
      <li>할인 쿠폰 및 특가 정보</li>
      <li>맞춤형 상품 추천</li>
      <li>시즌별 패션 트렌드 정보</li>
      <li>회원 대상 혜택 및 포인트 안내</li>
      <li>설문조사 및 이벤트 참여 안내</li>
    </ol>

    <h2>제3조 (정보 제공 방법)</h2>
    <p>회사는 다음의 방법으로 마케팅 정보를 제공합니다.</p>
    <ol>
      <li>앱 푸시 알림</li>
      <li>이메일(E-mail)</li>
      <li>SMS(단문 문자 메시지)</li>
      <li>앱 내 공지사항 및 팝업</li>
    </ol>

    <h2>제4조 (개인정보의 수집 및 이용)</h2>
    <p><strong>1.</strong> 회사는 마케팅 정보 제공을 위해 다음의 개인정보를 수집·이용합니다.</p>
    <ul>
      <li>수집 항목: 이름, 이메일, 전화번호, 선호 키워드, 상품 구매 이력</li>
      <li>수집 목적: 맞춤형 마케팅 정보 제공, 이벤트 안내, 서비스 개선</li>
      <li>보유 기간: 동의 철회 시 또는 회원 탈퇴 시까지</li>
    </ul>

    <p><strong>2.</strong> 이용자는 위 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의를 거부하는 경우에도 서비스 이용에는 제한이 없습니다. 다만, 마케팅 정보 제공이 제한될 수 있습니다.</p>

    <h2>제5조 (동의의 철회)</h2>
    <p><strong>1.</strong> 이용자는 언제든지 마케팅 정보 수신 동의를 철회할 수 있습니다.</p>
    <p><strong>2.</strong> 동의 철회 방법은 다음과 같습니다.</p>
    <ul>
      <li>앱 내: 마이페이지 > 설정 > 알림 설정</li>
      <li>이메일: 수신 거부 링크 클릭</li>
      <li>SMS: 수신 거부 번호로 회신</li>
      <li>고객센터: admin@clozet.my으로 요청</li>
    </ul>

    <p><strong>3.</strong> 동의 철회 시 즉시 마케팅 정보 발송이 중단되며, 처리에 최대 3영업일이 소요될 수 있습니다.</p>

    <h2>제6조 (광고성 정보 전송 시간)</h2>
    <p>회사는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」에 따라 오후 9시부터 그 다음 날 오전 8시까지는 광고성 정보를 전송하지 않습니다. 단, 이용자가 별도로 동의한 경우에는 예외로 합니다.</p>

    <h2>제7조 (맞춤형 광고)</h2>
    <p><strong>1.</strong> 회사는 이용자의 서비스 이용 패턴, 구매 이력, 선호 키워드 등을 분석하여 맞춤형 광고를 제공할 수 있습니다.</p>
    <p><strong>2.</strong> 이용자는 앱 설정에서 맞춤형 광고 수신을 거부할 수 있으며, 거부 시에도 일반 광고는 계속 표시될 수 있습니다.</p>

    <h2>제8조 (제3자 제공)</h2>
    <p>회사는 마케팅 목적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 단, 다음의 경우는 예외로 합니다.</p>
    <ol>
      <li>이용자가 사전에 동의한 경우</li>
      <li>법령에 의거하여 제공이 요구되는 경우</li>
    </ol>

    <h2>제9조 (정보의 정확성)</h2>
    <p>회사는 이용자에게 정확하고 유익한 정보를 제공하기 위해 최선을 다합니다. 다만, 제공되는 정보의 정확성, 완전성, 적시성에 대해서는 보증하지 않습니다.</p>

    <h2>제10조 (이용자의 권리)</h2>
    <p><strong>1.</strong> 이용자는 다음의 권리를 가집니다.</p>
    <ul>
      <li>마케팅 정보 수신 동의 및 철회</li>
      <li>개인정보 열람, 정정, 삭제 요구</li>
      <li>개인정보 처리 정지 요구</li>
    </ul>

    <p><strong>2.</strong> 위 권리 행사는 회사에 서면, 전자우편 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체 없이 조치하겠습니다.</p>

    <h2>제11조 (동의의 선택적 적용)</h2>
    <p>이용자는 마케팅 정보 수신 방법(푸시, 이메일, SMS)별로 선택적으로 동의하거나 거부할 수 있습니다.</p>

    <h2>제12조 (변경 사항 통지)</h2>
    <p>본 동의서의 내용이 변경되는 경우, 회사는 변경사항을 이용자에게 사전에 공지합니다.</p>

    <h2>제13조 (문의처)</h2>
    <p>마케팅 정보 수신과 관련하여 문의사항이 있으신 경우 아래 연락처로 문의하시기 바랍니다.</p>
    <ul>
      <li>이메일: admin@clozet.my</li>
      <li>운영시간: 평일 10:00 ~ 18:00 (주말 및 공휴일 휴무)</li>
    </ul>

    <p><strong>부칙</strong><br>
    본 동의서는 2025년 11월 1일부터 시행됩니다.</p>

    <p><strong>회사 정보</strong><br>
    상호: 클로젯<br>
    대표: 김재원<br>
    사업자등록번호: [사업자등록번호 입력 필요]<br>
    이메일: admin@clozet.my</p>

    <hr>

    <p><strong>[동의 체크박스]</strong><br>
    □ 마케팅 정보 수신에 동의합니다. (선택)</p>

    <p><strong>[수신 방법 선택]</strong><br>
    □ 앱 푸시 알림<br>
    □ 이메일(E-mail)<br>
    □ SMS(문자 메시지)</p>

    <p><strong>※ 마케팅 정보 수신 동의는 선택사항이며, 동의하지 않아도 서비스 이용이 가능합니다.</strong><br>
    <strong>※ 동의 후에도 언제든지 마이페이지에서 수신 거부를 설정하실 수 있습니다.</strong></p>
  `;

  return (
    <TermsTemplate
      title="마케팅 정보 수신 동의"
      content={content}
      lastUpdated="2025년 11월 1일"
    />
  );
}
